import { Pipe, PipeTransform } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { App_FormBloc, App_FormStep } from 'src/app/utils/interfaces';

@Pipe({
  name: 'getArrayInFormPipe'
})
export class GetArrayInFormPipe implements PipeTransform {

  transform(form: FormGroup, step: App_FormStep, bloc: App_FormBloc, fieldOrLabel: any): FormArray | null {
    const stepformGroup = form.controls[step.name];
    if (stepformGroup instanceof FormGroup) {
      const blocFormGroup = stepformGroup.controls[bloc.name]
      if (blocFormGroup instanceof FormGroup) {
        const fieldControl = blocFormGroup.controls[fieldOrLabel.name]
        return fieldControl instanceof FormArray
        ? fieldControl
        : null
      }
    }
    return null;
  }

}
